module.exports = __webpack_public_path__ + "img/tit-five.00ea4d2b.png";